<div class="wrapper">
  <app-nav></app-nav>
  <router-outlet></router-outlet>
</div>
